<template>
  <div class="c-products">
    <a-menu theme="dark" mode="horizontal" :style="{ lineHeight: '50px' }">
      <a-menu-item key="index" v-show="false">
        <a href="#" @click="triggerNavChange(null)"> 主页 </a>
      </a-menu-item>
      <a-divider type="vertical" />
      <a-menu-item class="location ">
        <span> 当前位置：
          <template v-if="currentViewTitle === ''">
            <span> 管理控制台 </span>
          </template>
          <template v-if="currentViewTitle !== ''">
            <a href="#" @click="triggerNavChange(null)">
              管理控制台
            </a>
            <span class="pl-1 pr-1"> &gt; </span><span> {{currentViewTitle}} </span>
          </template>
        </span>
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>

export default {
  name: 'NavMenu',
  props: ['iframe', 'products'],
  mounted () {
  },
  computed: {
    currentViewTitle () {
      let result = '';
      if (this.iframe != null && this.iframe.title != null && this.iframe.title.length > 0) {
        result = this.iframe.title;
      }
      return result;
    }
  },
  methods: {
    triggerNavChange(view) {
      if (view === null) {
        this.$emit('nav-index')
        // this.currentViewTitle = ''
      } else if (view.type !== '_blank') {
        this.$emit('nav-change', view)
        // this.currentViewTitle = view.title
      }
      this.showProducts = false;
    },
    triggerProductMenu(flag) {
      window.clearTimeout(this.showOrHideProductsTimeOutIndex);
      if (flag) {
        this.showProducts = true;
      } else {
        this.showOrHideProductsTimeOutIndex = setTimeout(() => this.showProducts = false, 100);
      }
    },
    triggerProductSearch() {
      this.$message.info("查找：" + this.productSearchKeyword)
    },
    // 只显示前 32 个字符，超过部分用 ... 代替
    ajustProductDetail(detail) {
      detail = detail || '' // 防止空字符串异常
      return detail.substr(0, 32) + detail.substr(32).replace(/.+/, '...')
    },
  },
  data() {
    return {
      // currentViewTitle: '',
      showOrHideProductsTimeOutIndex: null,
      showProducts: false,
      productSearchKeyword: "",
    }
  }
}
</script>
<style lang="scss">
@import './index.scss';
</style>
